<template>
  <div class="job-detail-description">
    <div class="content">
        <div v-html="isEn() ? job.description : job.cn_description"></div>
    </div>
  </div>
</template>

<script>
import { isEn } from '@/i18n'

export default {
  props: {
    job: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isEn
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
.job-detail-description {

  .content {
    ::v-deep {
      ul, ol {
        list-style: disc;
        margin-top: 0px;
        margin-bottom: 0px;
        padding-left: 20px;
      }
      p {
        margin-top: 0px;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
